/** The league newsletter, on Substack. Shared by the header icon and the phone menu. */
export const NEWSLETTER_URL = 'https://ogjits.substack.com/';
